export default function Services() {
  const services = [
    {
      icon: 'ri-network-line',
      gradient: 'from-teal-500 to-cyan-600',
      title: 'Network Services',
      description: 'Comprehensive network infrastructure solutions for modern enterprises',
      features: [
        'SDWAN & SASE Implementation',
        'F5/AVI Load Balancer Deployment & Migration',
        'DDI Solution (Infoblox)',
        'Data Center & Remote Network Solutions',
        'Arista, Cisco ACI, Cisco NDFC',
        'Data Center Build & Migration Support'
      ]
    },
    {
      icon: 'ri-line-chart-line',
      gradient: 'from-cyan-500 to-teal-600',
      title: 'Consulting Services',
      description: 'Expert consulting for network and cloud infrastructure optimization',
      features: [
        'Automated DC Network Assessment',
        'Remote Office Network Analysis',
        'Cloud Infrastructure Evaluation',
        'Performance Optimization',
        'Security Audits',
        'Compliance Reviews'
      ]
    },
    {
      icon: 'ri-settings-3-line',
      gradient: 'from-teal-600 to-emerald-600',
      title: 'Network Automation',
      description: 'End-to-end automation solutions for seamless network operations',
      features: [
        'Complete Network Automation',
        'Configuration Management',
        'Automated Provisioning',
        'Self-Service Portals',
        'Workflow Orchestration',
        'Monitoring & Analytics'
      ]
    },
    {
      icon: 'ri-server-line',
      gradient: 'from-cyan-600 to-teal-700',
      title: 'Data Center Solutions',
      description: 'Build, migrate, and optimize your data center infrastructure',
      features: [
        'Data Center Design & Build',
        'Migration Planning & Execution',
        'Hybrid Cloud Integration',
        'Disaster Recovery',
        'Capacity Planning',
        'Infrastructure Modernization'
      ]
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-teal-600 text-sm font-semibold tracking-wider uppercase mb-3">
            OUR CORE SERVICES
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Network<br />& Cloud Solutions
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-16 h-16 rounded-lg bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 text-sm mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2 mb-6">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <a href="#contact" className="text-teal-600 text-sm font-semibold hover:text-teal-700 inline-flex items-center cursor-pointer">
                Learn More <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
